import { motion } from "framer-motion";

import SectionHead from "./SectionHead";
import { planColumns, planRows, planFootnote } from "../data/plan-rows";
import { revealContainer, fadeUp } from "../lib/motionVariants";

export default function Plans() {
  return (
    <motion.section
      id="plans"
      variants={revealContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      className="pb-7 pt-10 md:pb-12 md:pt-20"
    >
      <motion.div variants={fadeUp}>
        <SectionHead num="03" title="PLANS" meta="One-time build + monthly upkeep" />
      </motion.div>

      <motion.div variants={fadeUp} className="overflow-x-auto pt-2">
        <table className="w-full min-w-[620px] border-collapse text-[15px]">
          <caption className="sr-only">Feature comparison across the Basic, Pro and Custom plans</caption>
          <thead>
            <tr>
              <th scope="col" className="w-[34%] pb-3.5 pr-3 pt-[22px] text-left align-bottom">
                <span className="sr-only">Feature</span>
              </th>
              {planColumns.map((c) => (
                <th
                  key={c.name}
                  scope="col"
                  className={`border-b border-ink px-3 pb-3.5 pt-[22px] text-left align-bottom ${c.highlight ? "bg-ink-50" : ""}`}
                >
                  <p className="font-mono text-[11px] tracking-[0.2em] text-muted">{c.tag}</p>
                  <p className="mt-2 font-reactor text-[clamp(22px,2.4vw,32px)] font-bold leading-tight [font-variation-settings:'wdth'_5]">
                    {c.name}
                  </p>
                  <p className="mt-2.5 font-mono text-xs tracking-[0.08em]">{c.price}</p>
                  <p className="mt-1 font-mono text-[11px] tracking-[0.08em] text-muted">{c.upkeep}</p>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {planRows.map((row) => (
              <tr key={row.label}>
                <th scope="row" className="border-b border-border py-[11px] pr-3 text-left font-normal text-ink-600">
                  {row.label}
                </th>
                {row.values.map((v, i) => (
                  <td
                    key={i}
                    className={`border-b border-border px-3 py-[11px] font-mono text-xs ${planColumns[i].highlight ? "bg-ink-50" : ""} ${v ? "text-ink" : "text-ink-400"}`}
                  >
                    {v ? "YES" : "—"}
                    {!v && <span className="sr-only"> (not included)</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>

      <motion.p variants={fadeUp} className="mt-3 font-mono text-[10.5px] uppercase tracking-[0.14em] text-muted">
        {planFootnote}
      </motion.p>

      <motion.div
        variants={fadeUp}
        className="mt-5 flex flex-wrap items-center justify-between gap-5 border border-ink p-5 md:mt-8 md:p-8"
      >
        <div>
          <h3 className="font-reactor text-[clamp(22px,2.4vw,30px)] font-bold [font-variation-settings:'wdth'_5]">
            SOMETHING ELSE ENTIRELY?
          </h3>
          <p className="mt-2 max-w-[52ch] text-[17px] leading-snug text-ink-600">
            Migrations, unusual licensing models, custom specimen tools. Tell us what the foundry needs
            and we will quote it.
          </p>
        </div>
        <a
          href="#contact"
          className="bg-primary px-[26px] py-[14px] font-mono text-xs uppercase tracking-[0.1em] text-paper transition-colors duration-200 hover:bg-ink hover:text-paper"
        >
          Talk to us
        </a>
      </motion.div>
    </motion.section>
  );
}
